import Reveal from '@/components/base/Reveal';
import { responses } from '@/mocks/tracking';

const barMap = {
  primary: 'bg-primary-100 border-primary-200 text-primary-800',
  accent: 'bg-accent-100 border-accent-200 text-accent-800',
  secondary: 'bg-secondary-100 border-secondary-200 text-secondary-800',
} as const;

export default function Response() {
  return (
    <section id="response" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <Reveal>
        <div className="max-w-2xl">
          <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">原声记录</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">当事人回应全记录</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            原话照录，标注核验进度。频道只做搬运与标注，不替当事人下结论——回应了什么、证据到哪一步，一目了然。
          </p>
        </div>
      </Reveal>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
        {responses.map((res, idx) => (
          <Reveal key={res.id} delay={idx * 90}>
            <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-100 text-foreground-500">
                <i className="ri-double-quotes-l text-lg" />
              </span>
              <figcaption className="mt-4 font-label text-sm font-semibold text-foreground-800">{res.who}</figcaption>
              <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-foreground-700">“{res.quote}”</blockquote>
              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-label text-[11px] font-medium ${barMap[res.tone]}`}>
                  <i className="ri-check-double-line" />
                  {res.status}
                </span>
                <span className="font-label text-[11px] text-foreground-400">原文见备注</span>
              </div>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}